import { useQuery } from '@tanstack/react-query';

export const usePaginatedQuery = ({
    queryFn,
    queryKey,
    globalFilter,
    filters,
    sorting,
    pagination,
    enabled = true,
    ...rest
}) => {
    const { id: sortId, desc } = sorting?.[0] || {};
    const queryParams = {
        query: globalFilter ?? null,
        page: pagination != null ? pagination.pageIndex + 1 : 1,
        limit: pagination != null ? pagination.pageSize : 1000,
        filters: filters ?? null,
        sort: sortId
            ? { field: sortId, direction: desc ? 'desc' : 'asc' }
            : null,
    };

    return useQuery({
        ...rest,
        queryKey: [...queryKey, JSON.stringify(queryParams)],
        //queryKey: [...queryKey],
        queryFn: async () => await queryFn(queryParams),
        keepPreviousData: true,
        staleTime: 30_000,
        enabled,
    });
};
